<mat-card class="card" [ngClass]="{ 'card--full-height': fullHeight }">
    <ng-content></ng-content>
</mat-card>
